// // import { useEffect, useRef, useState } from "react";
// // import { Link, useParams } from "react-router-dom";
// // import { supabase } from "../lib/supabaseClient.ts";

// // function AdoptionShop() {
// //   const { id } = useParams();
// //   const [products, setProducts] = useState([]);
// //   const [isMobile, setIsMobile] = useState(false);
// //   const [sectionMeta, setSectionMeta] = useState(null);

// //   // Carousel state
// //   const carouselRef = useRef(null);
// //   const [currentIndex, setCurrentIndex] = useState(0);

// //   useEffect(() => {
// //     const handleResize = () => setIsMobile(window.innerWidth <= 768);
// //     handleResize();
// //     window.addEventListener("resize", handleResize);
// //     return () => window.removeEventListener("resize", handleResize);
// //   }, []);

// //   useEffect(() => {
// //     const fetchBestSellers = async () => {
// //       const { data: section, error: error1 } = await supabase
// //         .from("best_sellers_section")
// //         .select("*")
// //         .maybeSingle();

// //       const { data: products, error: error2 } = await supabase
// //         .from("products")
// //         .select("*")
// //         .eq("best", true);

// //       if (!error1 && section) setSectionMeta(section);
// //       if (!error2 && products) setProducts(products);
// //     };

// //     fetchBestSellers();
// //   }, []);

// //   const filteredProducts = products.slice(0, 6);

// //   const visibleCount = 3;
// //   const maxIndex = Math.max(0, filteredProducts.length - visibleCount);

// //   const scrollTo = (index) => {
// //     const newIndex = Math.min(Math.max(index, 0), maxIndex);
// //     setCurrentIndex(newIndex);
// //     if (carouselRef.current) {
// //       const cardWidth = carouselRef.current.offsetWidth / visibleCount;
// //       carouselRef.current.scrollTo({ left: newIndex * cardWidth, behavior: "smooth" });
// //     }
// //   };

// //   return (
// //     <section
// //       className="new-arrivals py-5"
// //       style={{ transform: isMobile ? "translateY(-70px)" : "none" }}
// //     >
// //       <div className="container">
// //         <div className="row justify-content-center">
// //           <div className="col-xl-7 col-lg-9">
// //             <div className="section-title text-center mb-65">
// //               <h5 className="sub-title" style={{ fontSize: isMobile ? "16px" : "38px" }}>
// //                 {sectionMeta?.subtitle || "Nouveaux produits"}
// //               </h5>

// //               <p
// //                 style={{
// //                   fontSize: isMobile ? "12px" : "14px",
// //                   textAlign: "center",
// //                   maxWidth: "500px",
// //                   margin: "auto",
// //                   lineHeight: "1.5",
// //                 }}
// //               >
// //                 {sectionMeta?.description ||
// //                   "Explorez les derniers produits ajoutés à notre boutique. Que ce soit pour chats, chiens ou pour le jeu, trouvez ce qu'il vous faut."}
// //               </p>
// //             </div>
// //           </div>
// //         </div>

// //         {/* ── MOBILE: untouched ── */}
// //         {isMobile && (
// //           <div
// //             className="scroll-container"
// //             style={{
// //               display: "flex",
// //               flexDirection: "row",
// //               overflowX: "auto",
// //               overflowY: "hidden",
// //               gap: "1rem",
// //               scrollSnapType: "x mandatory",
// //               padding: "0 16px",
// //               margin: "0",
// //               rowGap: "0",
// //               flexWrap: "nowrap",
// //               justifyContent: "flex-start",
// //               scrollbarWidth: "none",
// //               msOverflowStyle: "none",
// //             }}
// //           >
// //             {filteredProducts.map((product, index) => (
// //               <div
// //                 key={product.id}
// //                 className="adoption-shop-item"
// //                 style={{
// //                   scrollSnapAlign: "start",
// //                   flex: "0 0 72%",
// //                   width: "auto",
// //                   backgroundColor: "#F4F1EA",
// //                   borderRadius: "4px",
// //                   padding: "10px",
// //                   height: "303px",
// //                   display: "flex",
// //                   flexDirection: "column",
// //                   justifyContent: "space-between",
// //                 }}
// //               >
// //                 <Link to={`/shop-details/${product.id}`}>
// //                   <div
// //                     className="adoption-shop-thumb"
// //                     style={{
// //                       width: "100%",
// //                       height: "170px",
// //                       overflow: "hidden",
// //                       marginBottom: "8px",
// //                       display: "flex",
// //                       justifyContent: "center",
// //                       alignItems: "center",
// //                       position: "relative",
// //                     }}
// //                   >
// //                     <img
// //                       src={product.image}
// //                       alt={product.name}
// //                       style={{
// //                         width: product.id === 3 ? "60%" : "90%",
// //                         height: "100%",
// //                         objectFit: "contain",
// //                         backgroundColor: "transparent",
// //                         transform: index === 0 ? "translateX(10%)" : "none",
// //                       }}
// //                     />
// //                   </div>
// //                 </Link>

// //                 <div
// //                   className="adoption-shop-content"
// //                   style={{
// //                     textAlign: "center",
// //                     width: "90%",
// //                     height: "50%",
// //                     minHeight: "80px",
// //                     display: "flex",
// //                     flexDirection: "column",
// //                     justifyContent: "space-between",
// //                     marginLeft: "15px",
// //                     transform: "translateY(67px)",
// //                   }}
// //                 >
// //                   <h6
// //                     className="title"
// //                     style={{
// //                       fontSize: "14px",
// //                       marginBottom: "6px",
// //                       color: "black",
// //                       minHeight: "40px",
// //                       display: "flex",
// //                       alignItems: "center",
// //                       justifyContent: "center",
// //                     }}
// //                   >
// //                     <Link to={`/shop-details/${product.id}`}>
// //                       {product.name.length > 10
// //                         ? product.name.substring(0, 17) + "..."
// //                         : product.name}
// //                     </Link>                  </h6>
// //                   <div className="adoption-meta"><ul></ul></div>
// //                   {product.price_range && (
// //                     <div className="adoption-rating">
// //                       <ul style={{ padding: 0, margin: 0, listStyle: "none" }}>
// //                         <li
// //                           className="price"
// //                           style={{
// //                             fontSize: "15px",
// //                             color: "#ff41b4",
// //                             fontWeight: "bold",
// //                             textAlign: "right",
// //                             transform: "translateX(35px)",
// //                           }}
// //                         >
// //                           <span>
// //                             {new Intl.NumberFormat("fr-FR", {
// //                               minimumFractionDigits: 3,
// //                               maximumFractionDigits: 3,
// //                             }).format(parseFloat(product.price_range))}{" "}
// //                             DT
// //                           </span>
// //                         </li>
// //                       </ul>
// //                     </div>
// //                   )}
// //                 </div>
// //               </div>
// //             ))}
// //           </div>
// //         )}

// //         {/* ── DESKTOP: carousel ── */}
// //         {!isMobile && (
// //           <div style={{ position: "relative", margin: "0 10px" }}>

// //             {/* Left Arrow */}
// //             <button
// //               onClick={() => scrollTo(currentIndex - 1)}
// //               disabled={currentIndex === 0}
// //               style={{
// //                 position: "absolute",
// //                 left: "-45px",
// //                 top: "45%",
// //                 transform: "translateY(-50%)",
// //                 zIndex: 10,
// //                 background: currentIndex === 0 ? "#ccc" : "#ff41b4",
// //                 color: "white",
// //                 border: "none",
// //                 borderRadius: "50%",
// //                 width: "36px",
// //                 height: "36px",
// //                 fontSize: "20px",
// //                 cursor: currentIndex === 0 ? "default" : "pointer",
// //                 display: "flex",
// //                 alignItems: "center",
// //                 justifyContent: "center",
// //                 boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
// //               }}
// //             >
// //               ‹
// //             </button>

// //             {/* Carousel Track */}
// //             <div
// //               ref={carouselRef}
// //               className="scroll-container"
// //               style={{
// //                 display: "flex",
// //                 flexDirection: "row",
// //                 overflowX: "hidden",
// //                 overflowY: "hidden",
// //                 gap: "2.5rem",
// //                 scrollbarWidth: "none",
// //                 msOverflowStyle: "none",
// //               }}
// //             >
// //               {filteredProducts.map((product, index) => (
// //                 <div
// //                   key={product.id}
// //                   className="adoption-shop-item"
// //                   style={{
// //                     flex: "0 0 calc(33.33% - 2.5rem)",
// //                     width: "100%",
// //                     backgroundColor: "#F4F1EA",
// //                     borderRadius: "4px",
// //                     padding: "10px",
// //                     height: "303px",
// //                     display: "flex",
// //                     flexDirection: "column",
// //                     justifyContent: "space-between",
// //                   }}
// //                 >
// //                   <Link to={`/shop-details/${product.id}`}>
// //                     <div
// //                       className="adoption-shop-thumb"
// //                       style={{
// //                         width: "100%",
// //                         height: "170px",
// //                         overflow: "hidden",
// //                         marginBottom: "8px",
// //                         display: "flex",
// //                         justifyContent: "center",
// //                         alignItems: "center",
// //                         position: "relative",
// //                         objectFit: "contain",
// //                       }}
// //                     >
// //                       <img
// //                         src={product.image}
// //                         alt={product.name}
// //                         style={{
// //                           width: product.id === 3 ? "60%" : "90%",
// //                           height: "90%",
// //                           objectFit: "contain",
// //                           backgroundColor: "transparent",
// //                         }}
// //                       />
// //                     </div>
// //                   </Link>

// //                   <div
// //                     className="adoption-shop-content"
// //                     style={{
// //                       textAlign: "center",
// //                       width: "90%",
// //                       height: "50%",
// //                       minHeight: "80px",
// //                       display: "flex",
// //                       flexDirection: "column",
// //                       justifyContent: "space-between",
// //                       marginLeft: "15px",
// //                       transform: "translateY(67px)",
// //                     }}
// //                   >
// //                     <h6
// //                       className="title"
// //                       style={{
// //                         fontSize: "16px",
// //                         marginBottom: "6px",
// //                         color: "black",
// //                         minHeight: "40px",
// //                         display: "flex",
// //                         alignItems: "center",
// //                         justifyContent: "center",
// //                       }}
// //                     >
// //                       <Link to={`/shop-details/${product.id}`}>
// //                         {product.name.length > 10
// //                           ? product.name.substring(0, 20) + "..."
// //                           : product.name}
// //                       </Link>                    </h6>
// //                     <div className="adoption-meta"><ul></ul></div>
// //                     {product.price_range && (
// //                       <div className="adoption-rating">
// //                         <ul style={{ padding: 0, margin: 0, listStyle: "none" }}>
// //                           <li
// //                             className="price"
// //                             style={{
// //                               fontSize: "15px",
// //                               color: "#ff41b4",
// //                               fontWeight: "bold",
// //                               textAlign: "right",
// //                               transform: "translateX(60px)",
// //                             }}
// //                           >
// //                             <span>
// //                               {new Intl.NumberFormat("fr-FR", {
// //                                 minimumFractionDigits: 3,
// //                                 maximumFractionDigits: 3,
// //                               }).format(parseFloat(product.price_range))}{" "}
// //                               DT
// //                             </span>
// //                           </li>
// //                         </ul>
// //                       </div>
// //                     )}
// //                   </div>
// //                 </div>
// //               ))}
// //             </div>

// //             {/* Right Arrow */}
// //             <button
// //               onClick={() => scrollTo(currentIndex + 1)}
// //               disabled={currentIndex >= maxIndex}
// //               style={{
// //                 position: "absolute",
// //                 right: "-45px",
// //                 top: "45%",
// //                 transform: "translateY(-50%)",
// //                 zIndex: 10,
// //                 background: currentIndex >= maxIndex ? "#ccc" : "#ff41b4",
// //                 color: "white",
// //                 border: "none",
// //                 borderRadius: "50%",
// //                 width: "36px",
// //                 height: "36px",
// //                 fontSize: "20px",
// //                 cursor: currentIndex >= maxIndex ? "default" : "pointer",
// //                 display: "flex",
// //                 alignItems: "center",
// //                 justifyContent: "center",
// //                 boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
// //               }}
// //             >
// //               ›
// //             </button>

// //             {/* Dots */}
// //             <div style={{ display: "flex", justifyContent: "center", gap: "8px", marginTop: "20px" }}>
// //               {Array.from({ length: maxIndex + 1 }).map((_, i) => (
// //                 <button
// //                   key={i}
// //                   onClick={() => scrollTo(i)}
// //                   style={{
// //                     width: i === currentIndex ? "24px" : "8px",
// //                     height: "8px",
// //                     borderRadius: "4px",
// //                     background: i === currentIndex ? "#ff41b4" : "#ccc",
// //                     border: "none",
// //                     cursor: "pointer",
// //                     padding: 0,
// //                     transition: "all 0.3s ease",
// //                   }}
// //                 />
// //               ))}
// //             </div>
// //           </div>
// //         )}

// //         {filteredProducts.length === 0 && (
// //           <div className="col-12 text-center">
// //             <p className="text-muted">Aucun produit trouvé.</p>
// //           </div>
// //         )}
// //       </div>
// //     </section>
// //   );
// // }

// // export default AdoptionShop;
// import { useEffect, useRef, useState } from "react";
// import { Link, useParams } from "react-router-dom";
// import { supabase } from "../lib/supabaseClient.ts";

// function AdoptionShop() {
//   const { id } = useParams();
//   const [products, setProducts] = useState([]);
//   const [isMobile, setIsMobile] = useState(false);
//   const [sectionMeta, setSectionMeta] = useState(null);
//   const carouselRef = useRef(null);
//   const [currentPage, setCurrentPage] = useState(0);

//   const COLS = 5;
//   const ROWS = 4;
//   const PER_PAGE = COLS * ROWS; // 20 per page

//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth <= 768);
//     handleResize();
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     const fetchBestSellers = async () => {
//       const { data: section, error: error1 } = await supabase
//         .from("best_sellers_section")
//         .select("*")
//         .maybeSingle();

//       const { data: prods, error: error2 } = await supabase
//         .from("products")
//         .select("*")
//         .eq("best", true);

//       if (!error1 && section) setSectionMeta(section);
//       if (!error2 && prods) setProducts(prods);
//     };
//     fetchBestSellers();
//   }, []);

//   const filteredProducts = products.filter(
//     (p) => p.price_range && !String(p.price_range).includes("–")
//   );

//   const totalPages = Math.ceil(filteredProducts.length / PER_PAGE);
//   const currentProducts = filteredProducts.slice(
//     currentPage * PER_PAGE,
//     (currentPage + 1) * PER_PAGE
//   );

//   const goTo = (page) => {
//     const p = Math.min(Math.max(page, 0), totalPages - 1);
//     setCurrentPage(p);
//     window.scrollTo({
//       top: (carouselRef.current?.offsetTop || 200) - 100,
//       behavior: "smooth",
//     });
//   };

//   const formatPrice = (price_range) =>
//     new Intl.NumberFormat("fr-FR", {
//       minimumFractionDigits: 3,
//       maximumFractionDigits: 3,
//     }).format(parseFloat(price_range));

//   return (
//     <section className="new-arrivals py-5">
//       <style>{`
//         .bs-grid {
//           display: grid;
//           grid-template-columns: repeat(5, 1fr);
//           gap: 16px;
//           width: 100%;
//         }
//         @media (max-width: 1100px) {
//           .bs-grid { grid-template-columns: repeat(4, 1fr); }
//         }

//         .bs-card {
//           background: #F4F1EA;
//           border-radius: 12px;
//           padding: 10px;
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           transition: transform 0.2s ease, box-shadow 0.2s ease;
//           text-decoration: none;
//           min-height: 220px;
//         }
//         .bs-card:hover {
//           transform: translateY(-3px);
//           box-shadow: 0 6px 20px rgba(0,0,0,0.12);
//         }

//         .bs-img-wrap {
//           width: 100%;
//           height: 130px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           position: relative;
//           overflow: hidden;
//           border-radius: 8px;
//           background: #fff;
//         }
//         .bs-img-wrap img {
//           max-width: 90%;
//           max-height: 120px;
//           object-fit: contain;
//           display: block;
//           margin: 0 auto;
//         }

//         .bs-body {
//           width: 100%;
//           text-align: center;
//           margin-top: 8px;
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           gap: 4px;
//           flex: 1;
//         }
//         .bs-name {
//           font-size: 0.78rem;
//           font-weight: 600;
//           color: #222;
//           line-height: 1.3;
//           margin: 0;
//           word-break: break-word;
//         }
//         .bs-price {
//           font-size: 0.88rem;
//           color: #ff41b4;
//           font-weight: 700;
//           margin: 0;
//         }

//         .bs-arrow {
//           position: absolute;
//           top: 45%;
//           transform: translateY(-50%);
//           z-index: 10;
//           background: #ff41b4;
//           color: white;
//           border: none;
//           border-radius: 50%;
//           width: 36px;
//           height: 36px;
//           font-size: 20px;
//           cursor: pointer;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           box-shadow: 0 2px 8px rgba(0,0,0,0.15);
//           transition: background 0.2s;
//         }
//         .bs-arrow:disabled {
//           background: #ccc;
//           cursor: default;
//         }

//         .bs-dots {
//           display: flex;
//           justify-content: center;
//           gap: 8px;
//           margin-top: 24px;
//         }
//         .bs-dot {
//           height: 8px;
//           border-radius: 4px;
//           border: none;
//           cursor: pointer;
//           padding: 0;
//           transition: all 0.3s ease;
//           background: #ccc;
//         }
//         .bs-dot.active {
//           width: 24px !important;
//           background: #ff41b4;
//         }

//         .bs-mobile-scroll {
//           display: flex;
//           flex-direction: row;
//           overflow-x: auto;
//           gap: 10px;
//           scroll-snap-type: x mandatory;
//           padding: 0 8px 8px;
//           scrollbar-width: none;
//           -ms-overflow-style: none;
//         }
//         .bs-mobile-scroll::-webkit-scrollbar { display: none; }

//         .bs-mobile-card {
//           scroll-snap-align: start;
//           flex: 0 0 44%;
//           background: #F4F1EA;
//           border-radius: 12px;
//           padding: 10px;
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           min-height: 200px;
//           text-decoration: none;
//         }
//         .bs-mobile-card .bs-img-wrap {
//           width: 100%;
//           height: 120px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           background: #fff;
//           border-radius: 8px;
//           overflow: hidden;
//           position: relative;
//         }
//         .bs-mobile-card .bs-img-wrap img {
//           max-width: 85%;
//           max-height: 105px;
//           object-fit: contain;
//           display: block;
//   margin-left: 190px;
//         }
//       `}</style>

//       <div className="container">
//         {/* Section header */}
//         <div className="row justify-content-center">
//           <div className="col-xl-7 col-lg-9">
//             <div className="section-title text-center mb-65">
//               <h5
//                 className="sub-title"
//                 style={{ fontSize: isMobile ? "16px" : "38px" }}
//               >
//                 {sectionMeta?.subtitle || "Meilleures Ventes"}
//               </h5>
//               <p
//                 style={{
//                   fontSize: isMobile ? "12px" : "14px",
//                   textAlign: "center",
//                   maxWidth: "500px",
//                   margin: "auto",
//                   lineHeight: "1.5",
//                 }}
//               >
//                 {sectionMeta?.description ||
//                   "Explorez les produits les plus appréciés par nos clients."}
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* ── DESKTOP ── */}
//         {!isMobile && (
//           <div ref={carouselRef} style={{ position: "relative", padding: "0 48px" }}>
//             {/* Left arrow */}
//             <button
//               className="bs-arrow"
//               style={{ left: 0 }}
//               onClick={() => goTo(currentPage - 1)}
//               disabled={currentPage === 0}
//             >
//               ‹
//             </button>

//             {/* Grid */}
//             <div className="bs-grid">
//               {currentProducts.map((product) => (
//                 <Link
//                   key={product.id}
//                   to={`/shop-details/${product.id}`}
//                   className="bs-card"
//                 >
//                   <div className="bs-img-wrap">
//                     <img src={product.image} alt={product.name} />
//                   </div>
//                   <div className="bs-body">
//                     <p className="bs-name">
//                       {product.name.length > 22
//                         ? product.name.substring(0, 22) + "…"
//                         : product.name}
//                     </p>
//                     {product.price_range && (
//                       <p className="bs-price">
//                         {formatPrice(product.price_range)} DT
//                       </p>
//                     )}
//                   </div>
//                 </Link>
//               ))}
//             </div>

//             {/* Right arrow */}
//             <button
//               className="bs-arrow"
//               style={{ right: 0 }}
//               onClick={() => goTo(currentPage + 1)}
//               disabled={currentPage >= totalPages - 1}
//             >
//               ›
//             </button>

//             {/* Dots */}
//             {totalPages > 1 && (
//               <div className="bs-dots">
//                 {Array.from({ length: totalPages }).map((_, i) => (
//                   <button
//                     key={i}
//                     className={`bs-dot${i === currentPage ? " active" : ""}`}
//                     style={{ width: i === currentPage ? "24px" : "8px" }}
//                     onClick={() => goTo(i)}
//                   />
//                 ))}
//               </div>
//             )}
//           </div>
//         )}

//         {/* ── MOBILE horizontal scroll ── */}
//         {isMobile && (
//           <div className="bs-mobile-scroll">
//             {filteredProducts.map((product) => (
//               <Link
//                 key={product.id}
//                 to={`/shop-details/${product.id}`}
//                 className="bs-mobile-card"
//               >
//                 <div className="bs-img-wrap">
//                   <img src={product.image} alt={product.name} />
//                 </div>
//                 <div className="bs-body">
//                   <p className="bs-name">
//                     {product.name.length > 18
//                       ? product.name.substring(0, 18) + "…"
//                       : product.name}
//                   </p>
//                   {product.price_range && (
//                     <p className="bs-price">
//                       {formatPrice(product.price_range)} DT
//                     </p>
//                   )}
//                 </div>
//               </Link>
//             ))}
//           </div>
//         )}

//         {filteredProducts.length === 0 && (
//           <div className="col-12 text-center">
//             <p className="text-muted">Aucun produit trouvé.</p>
//           </div>
//         )}
//       </div>
//     </section>
//   );
// }

// export default AdoptionShop;
import { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { supabase } from "../lib/supabaseClient.ts";

function AdoptionShop() {
  const { id } = useParams();
  const [products, setProducts] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [sectionMeta, setSectionMeta] = useState(null);
  const carouselRef = useRef(null);
  const mobileRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [mobileCurrentPage, setMobileCurrentPage] = useState(0);

  const COLS = 5;
  const ROWS = 4;
  const PER_PAGE = COLS * ROWS;

  const MOBILE_COLS = 2;
  const MOBILE_ROWS = 4;
  const MOBILE_PER_PAGE = MOBILE_COLS * MOBILE_ROWS;

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchBestSellers = async () => {
      const { data: section, error: error1 } = await supabase
        .from("best_sellers_section").select("*").maybeSingle();
      const { data: prods, error: error2 } = await supabase
        .from("products").select("*").eq("best", true);
      if (!error1 && section) setSectionMeta(section);
      if (!error2 && prods) setProducts(prods);
    };
    fetchBestSellers();
  }, []);

  const filteredProducts = products.filter(
    (p) => p.price_range && !String(p.price_range).includes("–")
  );

  // Desktop pagination
  const totalPages = Math.ceil(filteredProducts.length / PER_PAGE);
  const currentProducts = filteredProducts.slice(
    currentPage * PER_PAGE,
    (currentPage + 1) * PER_PAGE
  );

  // Mobile pagination
  const mobileTotalPages = Math.ceil(filteredProducts.length / MOBILE_PER_PAGE);
  const mobileCurrentProducts = filteredProducts.slice(
    mobileCurrentPage * MOBILE_PER_PAGE,
    (mobileCurrentPage + 1) * MOBILE_PER_PAGE
  );

  const goTo = (page) => {
    const p = Math.min(Math.max(page, 0), totalPages - 1);
    setCurrentPage(p);
    window.scrollTo({
      top: (carouselRef.current?.offsetTop || 200) - 100,
      behavior: "smooth",
    });
  };

  const goToMobile = (page) => {
    const p = Math.min(Math.max(page, 0), mobileTotalPages - 1);
    setMobileCurrentPage(p);
    window.scrollTo({
      top: (mobileRef.current?.offsetTop || 200) - 80,
      behavior: "smooth",
    });
  };

  // ─── Price helpers ────────────────────────────────────────────────────────────
  const fmt = (n) =>
    new Intl.NumberFormat("fr-FR", {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3,
    }).format(n);

  const parsePrice = (val) => {
    if (val == null) return NaN;
    return parseFloat(String(val).replace(",", "."));
  };

  const renderPrice = (product) => {
    const priceRangeRaw = parsePrice(product.price_range);
    const oldPriceRaw = parsePrice(product.old_price);

    if (!product.promo) {
      return isNaN(priceRangeRaw) ? null : (
        <p className="bs-price">{fmt(priceRangeRaw)} DT</p>
      );
    }

    const promoType = product.promo_type || "percentage";
    const pct = product.promo_percentage || 0;

    let finalPrice, oldPrice;

    if (promoType === "exact") {
      oldPrice = isNaN(oldPriceRaw) ? null : oldPriceRaw;
      finalPrice = isNaN(priceRangeRaw) ? null : priceRangeRaw;
    } else {
      const base = !isNaN(oldPriceRaw) ? oldPriceRaw : priceRangeRaw;
      oldPrice = isNaN(base) ? null : base;
      finalPrice = (!isNaN(base) && pct) ? base * (1 - pct / 100) : (isNaN(priceRangeRaw) ? null : priceRangeRaw);
    }

    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "2px" }}>
        {oldPrice != null && (
          <span style={{ fontSize: "0.72rem", color: "#999", textDecoration: "line-through", lineHeight: 1 }}>
            {fmt(oldPrice)} DT
          </span>
        )}
        {finalPrice != null && (
          <p className="bs-price" style={{ margin: 0 }}>{fmt(finalPrice)} DT</p>
        )}
      </div>
    );
  };

  const promoLabel = (product) => {
    if (product.promo_type === "exact" && product.old_price && product.price_range) {
      const pct = ((parsePrice(product.old_price) - parsePrice(product.price_range)) / parsePrice(product.old_price) * 100).toFixed(0);
      return `-${pct}%`;
    }
    return product.promo_percentage ? `-${product.promo_percentage}%` : "Promo";
  };

  return (
    <section className="new-arrivals py-5">
      <style>{`
        /* ── DESKTOP GRID ── */
        .bs-grid {
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          gap: 16px;
          width: 100%;
        }
        @media (max-width: 1100px) {
          .bs-grid { grid-template-columns: repeat(4, 1fr); }
        }

        .bs-card {
          background: #F4F1EA;
          border-radius: 12px;
          padding: 10px;
          display: flex;
          flex-direction: column;
          align-items: center;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
          text-decoration: none;
          min-height: 220px;
        }
        .bs-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 6px 20px rgba(0,0,0,0.12);
        }

        .bs-img-wrap {
          width: 100%;
          height: 130px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          overflow: hidden;
          border-radius: 8px;
          background: #fff;
        }
        .bs-img-wrap img {
          max-width: 90%;
          max-height: 120px;
          object-fit: contain;
          display: block;
          margin: 0 auto;
        }

        .bs-promo-badge {
          position: absolute;
          top: 6px;
          right: 6px;
          background: #28a745;
          color: #fff;
          font-size: 0.6rem;
          font-weight: 700;
          padding: 2px 6px;
          border-radius: 8px;
        }

        .bs-body {
          width: 100%;
          text-align: center;
          margin-top: 8px;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 4px;
          flex: 1;
        }
        .bs-name {
          font-size: 0.78rem;
          font-weight: 600;
          color: #222;
          line-height: 1.3;
          margin: 0;
          word-break: break-word;
        }
        .bs-price {
          font-size: 0.88rem;
          color: #ff41b4;
          font-weight: 700;
          margin: 0;
        }

        /* ── DESKTOP ARROWS ── */
        .bs-arrow {
          position: absolute;
          top: 45%;
          transform: translateY(-50%);
          z-index: 10;
          background: #ff41b4;
          color: white;
          border: none;
          border-radius: 50%;
          width: 36px;
          height: 36px;
          font-size: 20px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 2px 8px rgba(0,0,0,0.15);
          transition: background 0.2s;
        }
        .bs-arrow:disabled { background: #ccc; cursor: default; }

        /* ── DOTS (shared desktop + mobile) ── */
        .bs-dots {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 8px;
          margin-top: 24px;
        }
        .bs-dot {
          height: 8px;
          border-radius: 4px;
          border: none;
          cursor: pointer;
          padding: 0;
          transition: all 0.3s ease;
          background: #ddd;
        }
        .bs-dot.active {
          width: 24px !important;
          background: #ff41b4;
        }

        /* ── MOBILE GRID ── */
        .bs-mobile-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 12px;
          width: 100%;
          animation: bsFadeIn 0.3s ease;
        }

        @keyframes bsFadeIn {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        .bs-mobile-card {
          background: #F4F1EA;
          border-radius: 14px;
          padding: 10px 8px;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-decoration: none;
          min-height: 190px;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }
        .bs-mobile-card:active {
          transform: scale(0.97);
        }

        .bs-mobile-card .bs-img-wrap {
         width: 100%;
  height: 110px;
  display: flex;
  align-items: center;      /* vertical center */
  justify-content: center;  /* horizontal center */
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
        }
        .bs-mobile-card .bs-img-wrap img {
        position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 85%;
  max-height: 100px;
  object-fit: contain;
        }

        .bs-mobile-card .bs-body {
          margin-top: 8px;
        }

        .bs-mobile-card .bs-name {
          font-size: 0.73rem;
        }

        .bs-mobile-card .bs-price {
          font-size: 0.82rem;
        }

        /* Mobile dots slightly larger touch targets */
        .bs-mobile-dots .bs-dot {
          height: 7px;
          min-width: 7px;
        }
        .bs-mobile-dots .bs-dot.active {
          width: 20px !important;
        }
      `}</style>

      <div className="container">
        {/* Section header */}
        <div className="row justify-content-center">
          <div className="col-xl-7 col-lg-9">
            <div className="section-title text-center mb-65">
              <h5 className="sub-title" style={{ fontSize: isMobile ? "16px" : "38px" }}>
                {sectionMeta?.subtitle || "Meilleures Ventes"}
              </h5>
              <p style={{ fontSize: isMobile ? "12px" : "14px", textAlign: "center", maxWidth: "500px", margin: "auto", lineHeight: "1.5" }}>
                {sectionMeta?.description || "Explorez les produits les plus appréciés par nos clients."}
              </p>
            </div>
          </div>
        </div>

        {/* ── DESKTOP ── */}
        {!isMobile && (
          <div ref={carouselRef} style={{ position: "relative", padding: "0 48px" }}>
            <button className="bs-arrow" style={{ left: 0 }} onClick={() => goTo(currentPage - 1)} disabled={currentPage === 0}>‹</button>

            <div className="bs-grid">
              {currentProducts.map((product) => (
                <Link key={product.id} to={`/shop-details/${product.id}`} className="bs-card">
                  <div className="bs-img-wrap">
                    <img src={product.image} alt={product.name} />
                    {product.promo && (
                      <span className="bs-promo-badge">{promoLabel(product)}</span>
                    )}
                  </div>
                  <div className="bs-body">
                    <p className="bs-name">
                      {product.name.length > 22 ? product.name.substring(0, 22) + "…" : product.name}
                    </p>
                    {product.price_range && renderPrice(product)}
                  </div>
                </Link>
              ))}
            </div>

            <button className="bs-arrow" style={{ right: 0 }} onClick={() => goTo(currentPage + 1)} disabled={currentPage >= totalPages - 1}>›</button>

            {totalPages > 1 && (
              <div className="bs-dots">
                {Array.from({ length: totalPages }).map((_, i) => (
                  <button
                    key={i}
                    className={`bs-dot${i === currentPage ? " active" : ""}`}
                    style={{ width: i === currentPage ? "24px" : "8px" }}
                    onClick={() => goTo(i)}
                  />
                ))}
              </div>
            )}
          </div>
        )}

        {/* ── MOBILE ── */}
        {isMobile && (
          <div ref={mobileRef}>
            <div className="bs-mobile-grid">
              {mobileCurrentProducts.map((product) => (
                <Link key={product.id} to={`/shop-details/${product.id}`} className="bs-mobile-card">
                  <div className="bs-img-wrap">
                    <img src={product.image} alt={product.name} />
                    {product.promo && (
                      <span className="bs-promo-badge">{promoLabel(product)}</span>
                    )}
                  </div>
                  <div className="bs-body">
                    <p className="bs-name">
                      {product.name.length > 18 ? product.name.substring(0, 18) + "…" : product.name}
                    </p>
                    {product.price_range && renderPrice(product)}
                  </div>
                </Link>
              ))}
            </div>

            {mobileTotalPages > 1 && (
              <div className="bs-dots bs-mobile-dots">
                {Array.from({ length: mobileTotalPages }).map((_, i) => (
                  <button
                    key={i}
                    className={`bs-dot${i === mobileCurrentPage ? " active" : ""}`}
                    style={{ width: i === mobileCurrentPage ? "20px" : "7px" }}
                    onClick={() => goToMobile(i)}
                  />
                ))}
              </div>
            )}
          </div>
        )}

        {filteredProducts.length === 0 && (
          <div className="col-12 text-center">
            <p className="text-muted">Aucun produit trouvé.</p>
          </div>
        )}
      </div>
    </section>
  );
}

export default AdoptionShop;